import { HttpClient } from 'api/http-client';
class CustomAutomationsHttpClient extends HttpClient {
    getAllAutomations() {
        return this.get('/custom-automations?automationType=CUSTOM_AUTOMATION');
    }
    getAllAutomationsForParams(params) {
        return this.get('/custom-automations', {
            params
        });
    }
}
export const CustomAutomationsApi = new CustomAutomationsHttpClient();
